import { mdiStop, mdiVolumeHigh } from "@mdi/js";
import { splitProps } from "solid-js";
import { useSpeech } from "~/providers/SpeechProvider/context";
import { htmlToReadableText } from "~/util/dom";
import { cn } from "~/util/utils";
import { ActionIcon, type ActionIconProps } from "../ui/icon";

export interface SpeechButtonProps extends Omit<ActionIconProps, "path"> {
	value: string | (() => Promise<string>);
}

export function SpeechButton(props: SpeechButtonProps) {
	const [local, other] = splitProps(props, ["class", "value"]);
	const { isListening, read, stop } = useSpeech();

	const handleClick = async () => {
		const listening = isListening();

		if (listening) {
			return stop();
		}

		const promise = new Promise<string>((resolve) => {
			if (typeof local.value === "string") {
				resolve(local.value);
			} else if (typeof local.value === "function") {
				local.value().then(resolve);
			}
		});

		promise.then(htmlToReadableText).then(read);
	};

	return (
		<ActionIcon
			class={cn("min-w-10 min-h-10 max-h-10 max-w-10", local.class)}
			radius="xl"
			aria-label="Text to speech"
			onClick={handleClick}
			path={isListening() ? mdiStop : mdiVolumeHigh}
			variant={isListening() ? "accent" : "outline"}
			{...other}
		/>
	);
}
